export enum CoatingTypeEnum {
    Unknown = 0,
    StainlessSteel = 1,
    Epoxy = 2,
    Zink = 3,
    MarineLine = 4,
}

export const getCoatingTypeName = (type: CoatingTypeEnum | number): string => {
    const typeValue = typeof type === 'number' ? type : type;

    switch (typeValue) {
        case CoatingTypeEnum.StainlessSteel:
            return 'Stainless Steel';
        case CoatingTypeEnum.Epoxy:
            return 'Epoxy';
        case CoatingTypeEnum.Zink:
            return 'Zink';
        case CoatingTypeEnum.MarineLine:
            return 'Marine Line';
        case CoatingTypeEnum.Unknown:
        default:
            return 'Unknown';
    }
};
